var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-upgrade-container",attrs:{"id":"modal-upgrade"}},[_c('h1',{staticClass:"title header-title text-center"},[_vm._v("My Billing")]),_c('p',{staticClass:"header-subtitle text-center"},[_vm._v("For better features upgrade to a better plan!")]),_c('BillingCards'),_c('Flash',{ref:"show"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }